import { IClassname } from '@/lib/shared/model/classname';

export const FilterShop = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.55814 18.4186C6.55814 18.838 6.72475 19.2403 7.02132 19.5368C7.31789 19.8334 7.72012 20 8.13954 20C8.55895 20 8.96118 19.8334 9.25775 19.5368C9.55432 19.2403 9.72093 18.838 9.72093 18.4186M12.093 18.4186C12.093 18.838 12.2596 19.2403 12.5562 19.5368C12.8528 19.8334 13.255 20 13.6744 20C14.0938 20 14.4961 19.8334 14.7926 19.5368C15.0892 19.2403 15.2558 18.838 15.2558 18.4186M7.74419 7.74419H20V7.94186L19.811 8.16563C17.8902 10.4468 16.837 13.3332 16.8372 16.3153V16.4419H6.55814V14.9553C6.55814 13.3107 6.50595 11.6676 6.25293 10.0435C5.81488 7.23181 4.84786 3 3 3"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
